export default function MacroBar({ macros, compact = false }) {
  const items = [
    { label: "Cal",   val: macros.calories,    unit: "kcal", color: "#f97316" },
    { label: "Pro",   val: macros.protein,     unit: "g",    color: "#3b82f6" },
    { label: "Carb",  val: macros.carbs,       unit: "g",    color: "#22c55e" },
    { label: "Fat",   val: macros.fat,         unit: "g",    color: "#f59e0b" },
    { label: "Fiber", val: macros.fiber ?? 0,  unit: "g",    color: "#a78bfa" },
  ];
  return (
    <div style={{ display: "flex", gap: compact ? 6 : 10, flexWrap: "wrap" }}>
      {items.map(i => (
        <div key={i.label} style={{
          background: "rgba(255,255,255,0.05)", borderRadius: 8,
          padding: compact ? "4px 8px" : "6px 12px",
          display: "flex", flexDirection: "column", alignItems: "center",
          minWidth: compact ? 50 : 64,
        }}>
          <span style={{ fontFamily: "'Space Mono',monospace", fontSize: compact ? 12 : 15, fontWeight: 700, color: i.color }}>
            {i.val}
          </span>
          <span style={{ fontSize: 9, color: "#aaa", marginTop: 1 }}>{i.label} {i.unit}</span>
        </div>
      ))}
    </div>
  );
}
